export const MANUAL_ADJUSTMENT_REASON_OPTIONS = [
  { value: 'MISSING_PUNCH', label: 'Missing Punch' },
  { value: 'EMPLOYEE_FORGOT_CLOCK_IN', label: 'Employee Forgot Clock In' },
  { value: 'EMPLOYEE_FORGOT_CLOCK_OUT', label: 'Employee Forgot Clock Out' },
  { value: 'SYSTEM_AGENT_ISSUE', label: 'System / Agent Issue' },
  { value: 'APPROVED_ATTENDANCE_EXCEPTION', label: 'Approved Attendance Exception' },
  { value: 'SCHEDULE_CORRECTION', label: 'Schedule Correction' },
  { value: 'COVERAGE_CAMPAIGN_CORRECTION', label: 'Coverage / Campaign Correction' },
  { value: 'SUPERVISOR_CORRECTION', label: 'Supervisor Correction' },
  { value: 'OTHER', label: 'Other' },
] as const;
